type IconName =
  | "chat"
  | "tasks"
  | "library"
  | "research"
  | "history"
  | "cost"
  | "settings"
  | "home"
  | "inbox"
  | "search"
  | "pin"
  | "google"
  | "external"
  | "plus"
  | "send"
  | "stop"
  | "spark"
  | "doc";

interface Props {
  name: IconName;
  size?: number;
}

export default function Icon({ name, size = 16 }: Props) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
  };

  switch (name) {
    case "home":
      return (
        <svg {...common}>
          <path d="M2.5 7.5 8 3l5.5 4.5" />
          <path d="M4 7v6h8V7" />
          <path d="M6.5 13V9.5h3V13" />
        </svg>
      );
    case "inbox":
      return (
        <svg {...common}>
          <path d="M3 3.5h10l1 5.5v3.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9z" />
          <path d="M2.4 9h3.2l1 2h2.8l1-2h3.2" />
        </svg>
      );
    case "search":
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="4.2" />
          <path d="m10.2 10.2 3.3 3.3" />
        </svg>
      );
    case "pin":
      return (
        <svg {...common}>
          <path d="M5.5 2.5h5l-.8 4 2.3 2.3v1H4v-1l2.3-2.3z" />
          <path d="M8 10v3.5" />
        </svg>
      );
    case "google":
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path fill="#4285F4" d="M14.8 8.2c0-.5 0-.9-.1-1.3H8v2.5h3.8c-.2.8-.7 1.5-1.4 2v1.7h2.2c1.3-1.2 2.2-2.9 2.2-4.9Z" />
          <path fill="#34A853" d="M8 15c1.9 0 3.5-.6 4.6-1.8l-2.2-1.7c-.6.4-1.4.7-2.4.7-1.8 0-3.4-1.2-3.9-2.9H1.8V11C2.9 13.4 5.3 15 8 15Z" />
          <path fill="#FBBC05" d="M4.1 9.3c-.1-.4-.2-.8-.2-1.3s.1-.9.2-1.3V5H1.8C1.3 5.9 1 6.9 1 8s.3 2.1.8 3Z" />
          <path fill="#EA4335" d="M8 3.8c1 0 2 .4 2.7 1.1l2-2C11.5 1.7 9.9 1 8 1 5.3 1 2.9 2.6 1.8 5l2.3 1.7C4.6 5 6.2 3.8 8 3.8Z" />
        </svg>
      );
    case "external":
      return (
        <svg {...common}>
          <path d="M6.5 3.5h-3v9h9v-3" />
          <path d="M9 3.5h3.5V7" />
          <path d="m12.5 3.5-6 6" />
        </svg>
      );
    case "chat":
      return (
        <svg {...common}>
          <path d="M2.5 4.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4.8a2 2 0 0 1-2 2H7l-3.2 2.4v-2.4a2 2 0 0 1-1.3-1.9z" />
        </svg>
      );
    case "tasks":
      return (
        <svg {...common}>
          <rect x="2.5" y="2.5" width="11" height="11" rx="1.7" />
          <path d="m5 7 1.4 1.4L10.4 5" />
          <path d="M5 11h6" />
        </svg>
      );
    case "library":
      return (
        <svg {...common}>
          <path d="M3 3v10h2V3z" />
          <path d="M6.5 3v10h2V3z" />
          <path d="m10 4 3 .8-2 8.2-3-.8z" />
        </svg>
      );
    case "research":
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="4" />
          <path d="m10 10 3 3" />
        </svg>
      );
    case "history":
      return (
        <svg {...common}>
          <path d="M2.5 7.5A5.5 5.5 0 1 0 4 3.7L2.2 5.5" />
          <path d="M2.2 2.5v3h3" />
          <path d="M8 5.2v3.2l2 1.3" />
        </svg>
      );
    case "cost":
      return (
        <svg {...common}>
          <path d="M3 13V3" />
          <path d="M3 13h10" />
          <path d="M5.5 11V8.5" />
          <path d="M8 11V5" />
          <path d="M10.5 11V7" />
        </svg>
      );
    case "settings":
      return (
        <svg {...common}>
          <circle cx="8" cy="8" r="1.6" />
          <path d="M8 2.5v1.4M8 12.1v1.4M2.5 8h1.4M12.1 8h1.4M4 4l1 1M11 11l1 1M4 12l1-1M11 5l1-1" />
        </svg>
      );
    case "plus":
      return (
        <svg {...common}>
          <path d="M8 3.5v9" />
          <path d="M3.5 8h9" />
        </svg>
      );
    case "send":
      return (
        <svg {...common}>
          <path d="M2.5 8h11" />
          <path d="m8.5 3 5 5-5 5" />
        </svg>
      );
    case "stop":
      return (
        <svg {...common}>
          <rect x="4.5" y="4.5" width="7" height="7" rx="1" />
        </svg>
      );
    case "spark":
      return (
        <svg {...common}>
          <path d="M2.5 11.5 5.5 8 8 9.5 13.5 4.5" />
          <path d="M10.5 4.5h3v3" />
        </svg>
      );
    case "doc":
      return (
        <svg {...common}>
          <path d="M4 2.5h5l3 3V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1z" />
          <path d="M9 2.5v3h3" />
          <path d="M5.5 8h5" />
          <path d="M5.5 10.5h4" />
        </svg>
      );
  }
}
